import en from './translations/en.json';

const translations = { en };

const variableMatch = /\$?\{(\w+)\}/g;

export default function i18n(section, label, locale = 'en', variables = null) {
  if (!translations[locale] || !translations[locale][section]) {
    return '';
  }
  const translation = translations[locale][section][label] || '';

  if (variables === null) {
    return translation;
  }
  const replaceFn = (match, p1) => (variables[p1] !== undefined ? variables[p1] : '');
  return translation.replace(variableMatch, replaceFn);
}
